module.exports = __webpack_public_path__ + "media/images/photo-not-available-d39341fd.jpg";